import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import RedirectComponent from "./RedirectComponent.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/package/:path",
    name: "packageRedirect",
    component: RedirectComponent,
  },
  {
    path: "/:catchAll(.*)",
    name: "defaultRedirect", 
    component: RedirectComponent,
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;